import {observer} from "mobx-react";
import React from "react";
import themeState from "../state/themeState";
import experimentState, {ApplicationState} from "../state/experimentState";
import backend from "../backend";

const InstructionView = observer(
    class extends React.Component {
        /**
         * A simple instruction view
         * @param props
         */
        constructor(props) {
            super(props);
        }

        onClick() {
            let message = `Has finished instruction ${this.props.header_text}`
            experimentState.setApplicationState(this.props.next_app_state)
            backend.actionSendMessage(experimentState.useProfile.firstname, message)
        }


        render() {
            return <div>
                <header className="header" style={{backgroundColor:themeState.colour_primary}}><h1>{this.props.header_text}</h1></header>
                <section style={{display: "flex", flexDirection:"column",gap:"16px",}}>
                    {this.props.instructions.map((i,idx) => {
                        return React.cloneElement(i, {key: idx})
                    })}
                    <button style={{marginTop:"16px",padding:"16px", backgroundColor:themeState.colour_primary}}
                            onClick={this.onClick.bind(this)}>{this.props.button}</button>
                </section>

            </div>
        }
    }
)

export default InstructionView